import * as amplitude from "@amplitude/analytics-browser";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { checkTeamForAICompliance } from "@redotech/redo-model/agents/util/compliance-util";
import { useAiSlidePanel } from "@redotech/redo-web/ai/chat/contexts/ai-slide-panel-context";
import { memo, useContext } from "react";
import { PlatformEvents } from "../../../platform-events";
import { AskRedoButton } from "./ask-redo-button";
import { SearchButton } from "./search-button";
import { TeamSwitcher } from "./team-switcher";

export const MerchantAppTopNav = memo(function MerchantAppTopNav() {
  const { toggle } = useAiSlidePanel();
  const team = useContext(TeamContext);

  const isAiBlacklisted =
    team && !checkTeamForAICompliance(team._id.toString());

  return (
    <div
      className="flex w-full items-center justify-between px-3 bg-neutral-800 border-b border-neutral-700 overflow-hidden"
      style={{ height: "var(--redo-top-nav-height)" }}
    >
      <div className="flex-1 flex items-center justify-start gap-3 min-w-0">
        <TeamSwitcher />
      </div>

      <div className="flex-1 flex items-center justify-center gap-3 min-w-0">
        <SearchButton />
      </div>

      <div className="flex-1 flex items-center justify-end gap-3 min-w-0">
        {!isAiBlacklisted && (
          <AskRedoButton
            onClick={() => {
              amplitude.track(PlatformEvents.NAV_ASK_REDO_CLICKED);
              toggle();
            }}
          />
        )}
      </div>
    </div>
  );
});
